import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { getCurrencyIcon } from '../../../../../shared/js/get-currency-icon';

import CheckboxField from '../../../shared/form-elements/checkbox';

import map from 'lodash/map';
import find from 'lodash/find';

lessRequire('modules/profile/components/forms/balance.less');

const Balances = (props) => {
	const {
		updateBalances,
		toggleHiddenFromNavbarBalance,
		data,
		intl
	} = props;

	return (
		<form action="#"
			className="profile__balances clearfix"
		>
			<div className="profile-wrap__form-field clearfix">
				<div className="profile-wrap__position-left">
					{
						map(data.available, currency => {
							const checkedItem = find(data.connected, it => it.currency == currency.value);
							if (currency.value === 'rub' && !checkedItem) {
								return null;
							}
							const label = intl(`${currency.value}_s`) + ` ${getCurrencyIcon(currency.value)}`;
							return (
								<div className="avail_currency"  key={`${currency.value}`}>
									<Field
										name={currency.value}
										component={CheckboxField}
										shouldCheck={!!checkedItem}
										labelText={label + (checkedItem && checkedItem.is_hidden_on_navbar ? ' (hidden)' : '')}
										onChange={(e, d) => {
											e.preventDefault();
											if (d) {
												updateBalances({currency: e.target.id});
											} else {
												toggleHiddenFromNavbarBalance({currency: e.target.id});
											}
										}}
									/>
								</div>
							);
						})
					}
				</div>
			</div>
		</form>
	);
};

Balances.propTypes = {
	updateBalances: PropTypes.func,
	toggleHiddenFromNavbarBalance: PropTypes.func,
	data: PropTypes.object,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'profileBalancesForm'
})(Balances);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/forms/balance.js